import { nanoidGenerator } from 'features/common/helpers';

export const newService = {
	serviceType: '',
	keyId: nanoidGenerator(),
	reference: '',
	tariffProviderId: '',
	unit: [],
	cost: '',
	saleAmount: '',
	currency: '',
	markupPercentage: '',
	passengerIds: [],
	serviceProviderId: '',
};

export const tariffProviderNotAssignedId = 'jcnxv1tou0na468126b2jzlaufxwj1fd';
